import { getDictionaryItems } from '@/services/api';

export default {
  actions: {
    getLocations: async () => (await getDictionaryItems('LOCATION')).pageRows,
    getPrinterTypes: async () => (await getDictionaryItems('PRINTER_TYPE')).pageRows,
    getColorTypes: async () => (await getDictionaryItems('COLOR_TYPE')).pageRows,
    getPaperFormats: async () => (await getDictionaryItems('PAPER_FORMAT')).pageRows,
    getPrinterStatusCodes: async () => (await getDictionaryItems('STATUS')).pageRows,
    getNotificationTypes: async () => (await getDictionaryItems('NOTIFICATION_TYPE')).pageRows,
    getFileExtensionTypes: async () => (await getDictionaryItems('FILE_EXTENSION')).pageRows,
  }
}
